import React, { useContext } from 'react'

import type { TypeSectionGroup } from '../../../lib/types'
import { CompactSectionsContext } from '../../../contexts/compact-sections-context'
import { GroupPageSection } from '../../page-section/group'
import { SectionRenderer } from '../../renderer'
import type { ContentProps } from '../../renderer'
import { SectionContext } from '../../../contexts/section-context'
import { GroupTabSection } from '../tabs/tab-group-section'
import { SectionParallax } from '../parallax'

export const SectionGroupContent: React.FC<ContentProps<TypeSectionGroup>> = ({ structure }) => {
  const {
    fields: { heading, rows },
  } = structure

  const { isHero, indexInPage } = useContext(SectionContext)

  const [firstSection, ...otherSections] = rows || []

  return (
    <CompactSectionsContext.Provider value={true}>
      <SectionRenderer
        isHero={isHero}
        isH1Section={isHero && !heading?.fields?.title}
        isGrouped
        hasGroupHeading={!!heading}
        structure={firstSection}
        startIndexInPage={indexInPage}
      />
      <SectionRenderer
        isGrouped
        hasGroupHeading={!!heading}
        structure={otherSections}
        startIndexInPage={indexInPage && indexInPage + 1}
      />
    </CompactSectionsContext.Provider>
  )
}

export const SectionGroup: React.FC<ContentProps<TypeSectionGroup>> = ({ className, structure }) => {
  const {
    sys,
    fields: { internalName, heading, parallax, background, backgroundType },
  } = structure

  const { sectionGroupSwoosh } = useContext(SectionContext)

  if (parallax) {
    return <SectionParallax structure={structure} />
  }

  return (
    <GroupPageSection
      internalName={internalName}
      sysStructure={sys}
      className={className}
      heading={heading}
      background={background}
      backgroundType={backgroundType}
      sectionGroupSwoosh={sectionGroupSwoosh}
    >
      <SectionGroupContent structure={structure} />
    </GroupPageSection>
  )
}

export const SectionGroupForTabs: React.FC<ContentProps<TypeSectionGroup>> = ({ className, structure }) => {
  const {
    fields: { heading, background },
  } = structure

  const { sectionGroupSwoosh } = useContext(SectionContext)

  return (
    <GroupTabSection
      className={className}
      heading={heading}
      background={background}
      sectionGroupSwoosh={sectionGroupSwoosh}
    >
      <SectionGroupContent structure={structure} />
    </GroupTabSection>
  )
}
